import { useQuery } from '@tanstack/react-query';
import { getBulletStylesFromClient } from '../api/bullet-styles/getBulletStyles.api';

const KEY = 'bullet-styles';

export function useBulletStyles() {
   return useQuery({
      queryFn: () => getBulletStylesFromClient(),
      queryKey: [KEY],
   });
}
